export const toastPresets = {
    add: {
        loadingMessage: "Adding...",
        successMessage: "Added successfully!",
        errorMessage: "Failed to add.",
        toastOptions: { icon: "➕", position: "bottom-right", duration: 3000 },
    },
    update: {
        loadingMessage: "Updating...",
        successMessage: "Updated successfully!",
        errorMessage: "Failed to update.",
        toastOptions: { icon: "✏️", position: "bottom-right", duration: 3000 },
    },
    delete: {
        loadingMessage: "Deleting...",
        successMessage: "Deleted successfully!",
        errorMessage: "Failed to delete.",
        toastOptions: { icon: "🗑️", position: "bottom-right", duration: 3000 },
    },
    fetch: {
        loadingMessage: "Fetching data...",
        successMessage: "Data loaded successfully!",
        errorMessage: "Failed to fetch data.",
        toastOptions: { icon: "📦", position: "bottom-right", duration: 3000 },
    },
    default: {
        loadingMessage: "Processing...",
        successMessage: "Done!",
        errorMessage: "Something went wrong.",
        toastOptions: { icon: "🔄", position: "top-right", duration: 3000 },
    },
};
